<template>
  <v-combobox
    outline
    :deletable-chips="true"
    :chips="true"
    :readonly="readonly"
    :hint="hint"
    v-model="selectedValue"
    :items="options"
    :label="label"
    multiple
  ></v-combobox>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Tags',
  props: ['readonly', 'value', 'ajax', 'data', 'label', 'hint'],
  data() {
    return {
      endpoint: '',
      selectedValue: null,
      options: [],
      ajaxLoaded: false,
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal != null) {
          if (this.selectedValue != null) {
            if (this.selectedValue.value != newVal) {
              this.setValue(newVal)
            }
          } else {
            this.setValue(newVal)
          }
        } else {
          this.selectedValue = null
        }
      }
    },
    selectedValue: function (val) {
      if (val != null) {
        if (val != this.$props.value) {
          this.$nextTick(() => {
            this.$emit('input', val)
          })
        }
      } else {
        this.$nextTick(() => {
          this.$emit('input', null)
        })
      }
    },
  },
  methods: {
    setValue(newVal) {
      if (this.$props.ajax) {
        if (!this.ajaxLoaded) {
          this.$APICall(
            'get',
            'TAGS',
            '/' + this.endpoint,
            [],
            data => {
              this.options = data
              this.ajaxLoaded = true
              this.selectedValue = newVal
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        } else {
          this.selectedValue = newVal
        }
      } else {
        this.options = this.$props.data
        this.selectedValue = newVal
      }
    },
  },
  mounted() {
    if (this.$props.ajax) {
      this.endpoint = this.$props.data
    }
    this.setValue(this.$props.value)
  },
}
</script>

<style scoped></style>
